import { connect } from "react-redux";
import { getViewportCategory } from "../../state/modules/layout/selectors";
import SmallViewport from "./SmallViewportOnly";
import MediumLargeViewport from "./MediumLargeViewportOnly";

const mapStateToProps = state => ({
  viewportCategory: getViewportCategory(state)
});

const connected = connect(mapStateToProps);

export const SmallViewportOnly = connected(SmallViewport);

export const MediumLargeViewportOnly = connected(MediumLargeViewport);
